export default __webpack_public_path__ + "static/media/failure.bf4bc319.svg";